import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import customConfig from "../../../config";
import { updateEmailIDbyUserID } from "../../../action/user";
import { setAlert } from "../../../action/alert";
import { connect } from "react-redux";

const EMAIL_INVALID_MSG = "Email is not valid";

const UserInfoWrapper = ({
  children,
  withoutOnboard = false,
  updateEmailIDbyUserID,
  setAlert: showAlert,
  UserData,
  userRoleInfo,
  userById,
  tenantInfo
}) => {
  const [showUpdateEmailID, setShowUpdateEmailID] = useState(false);
  const [disabledEmailUpdateButton, setDisabledEmailUpdateButton] =
    useState(false);
  const user = userById ? userById : UserData.user;
  const { emailUpdateError, emailUpdateSuccess } = UserData;
  let [userEmailId, setUserEmailId] = useState("");
  useEffect(() => {
    setUserEmailId(user && user.email ? user.email : "");
  }, [user]);
  useEffect(() => {
    if (emailUpdateError) {
      cancelEmailPopup();
    }
  }, [emailUpdateError]);

  useEffect(() => {
    if (emailUpdateSuccess && userEmailId && userEmailId.length > 0) {
      user.email = userEmailId;
    }
  }, [emailUpdateSuccess]);

  // Visible email update form
  const showUpdateEmailPopup = () => {
    setDisabledEmailUpdateButton(userEmailId.length <= 0);
    setShowUpdateEmailID(!showUpdateEmailID);
  };

  const cancelEmailPopup = () => {
    setUserEmailId(user && user.email ? user.email.trim() : "");
    setShowUpdateEmailID(false);
    setDisabledEmailUpdateButton(false);
  };

  // Hit api to update email id
  const updateEmailIdClick = () => {
    const updatedEmailID = userEmailId.trim();
    const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
      updatedEmailID
    );
    if (!isValid) {
      showAlert(EMAIL_INVALID_MSG, "danger");
      return;
    }
    updateEmailIDbyUserID(user.userId, updatedEmailID, tenantInfo.tenantId);
    setShowUpdateEmailID(false);
  };

  const onChange = (e) => {
    if (e.target.value.trim().length > 0) setDisabledEmailUpdateButton(false);
    else setDisabledEmailUpdateButton(true);

    setUserEmailId(e.target.value);
  };
  return (
    <>
      {children({
        user,
        emailUpdateError,
        emailUpdateSuccess,
        userEmailId,
        showUpdateEmailID,
        disabledEmailUpdateButton,
        withoutOnboard,
        userRoleInfo,
        setShowUpdateEmailID,
        setDisabledEmailUpdateButton,
        showUpdateEmailPopup,
        cancelEmailPopup,
        updateEmailIdClick,
        onChange,
      })}
    </>
  );
};

UserInfoWrapper.propTypes = {
  children: PropTypes.func,
};

const mapStateToProps = (state) => ({
  UserData: state.user,
  user: state.user.user,
  userRoleInfo: {
    level: state.auth.userLevel,
    roles: state.auth.userRoles,
  },
  tenantInfo: state.tenant.tenantInfo
});

export default connect(mapStateToProps, {
  updateEmailIDbyUserID,
  setAlert,
})(UserInfoWrapper);
